var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagneticDooHold01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.52,13.52H2.48V2.48h11.03V13.52z M2.98,13.02h10.03V2.98H2.98V13.02z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.89,10.21V5.79h1.52c0.34,0,0.61,0.02,0.79,0.06c0.25,0.06,0.47,0.16,0.65,0.32c0.23,0.2,0.41,0.45,0.52,0.75 c0.12,0.31,0.17,0.66,0.17,1.05c0,0.33-0.04,0.63-0.12,0.89s-0.18,0.47-0.3,0.64C7,9.68,6.87,9.81,6.72,9.91 c-0.15,0.1-0.32,0.17-0.53,0.22c-0.21,0.05-0.44,0.08-0.71,0.08H3.89z M4.48,9.69h0.94c0.29,0,0.52-0.03,0.68-0.08 c0.17-0.05,0.3-0.13,0.4-0.23c0.14-0.14,0.25-0.33,0.32-0.56C6.9,8.58,6.94,8.3,6.94,7.97c0-0.46-0.08-0.82-0.23-1.06 S6.38,6.49,6.16,6.4C6,6.34,5.75,6.31,5.4,6.31H4.48V9.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.65,10.21V5.79h0.58v1.81h2.29V5.79h0.58v4.42h-0.58V8.13H9.23v2.08H8.65z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagneticDooHold01);
export default __webpack_public_path__ + "static/media/MagneticDooHold-01.82d28f485570451fabcfe71d3b422802.svg";
export { ForwardRef as ReactComponent };